import { NgModule } from '@angular/core';
import { PageTitleService } from './page-title.service';

@NgModule({
  providers: [
    PageTitleService
  ]
})
export class PageTitleModule { }
